function viewportModule() {
    this.create = function (min_width, max_width, callback) {
        var window_width = $(window).width();
        if (window_width >= min_width && window_width <= max_width) {
            callback();
        }
    };
}

module.exports = viewportModule;
